<template>
  <v-layout class="px-2" row wrap v-if="!isOld">
    <confirmation-header-text class="ml-3" icon="mdi-account-multiple"
                              text="Diplomatic Host Details"/>
    <v-flex sm3 class="pl-3" v-if="application_data">
      <list-item-detail
          :sub_title="application_data.relation"
          title="Relationship"/>
    </v-flex>
    <v-flex sm3 v-if="application_data && application_data.traveller">
      <list-item-detail
          :sub_title="application_data.traveller.full_name"
          :title="' Name of '+application_data.relation"/>
    </v-flex>
    <v-flex sm3 v-if="application_data && application_data.traveller">
      <list-item-detail
          :sub_title="application_data.traveller.gender"
          :title="'Gender of '+application_data.relation"/>
    </v-flex>
    <v-flex sm3 class="pl-3" v-if="application_data && application_data.traveller">
      <list-item-detail :sub_title="application_data.traveller.document_number"
                        title="Document number"/>
    </v-flex>
    <v-flex sm3 v-if="application_data && application_data.traveller">
      <list-item-detail :sub_title="application_data.traveller.dob"
                        title="Date of birth"/>
    </v-flex>
  </v-layout>
  <v-layout class="px-2" row wrap v-else>
    <v-flex xs12>
      <v-divider class="my-1"/>
    </v-flex>
    <confirmation-header-text class="ml-3" icon="mdi-account-multiple"
                              text="Relation Details"/>
    <v-flex sm4>
      <list-item-detail
          :sub_title="application_data.relation"
          title="Relationship"/>
    </v-flex>

  </v-layout>
</template>

<script>
import ListItemDetail from "../../ListItemDetail";
import ConfirmationHeaderText from "../../ConfirmationHeaderText";
import FileDisplay from "../../FileDisplay";

export default {
  computed: {
    application_data() {
      return this.$store.state.VisaRequestSingle.visaRequest.extra.application_data;
    },
    extra_traveller() {
      return this.$store.state.VisaRequestSingle.visaRequest.extra.extra_traveller;
    },
    isOld() {
      return this.$store.state.VisaRequestSingle.visaRequest.old;
    },
  },
  components: {
    ListItemDetail,
    ConfirmationHeaderText,
    FileDisplay
  }
};
</script>

<style>
</style>
